/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import 'cross-fetch/polyfill';
import { PANEL_LOG } from '@engine/actions/action-types';
/**
 * Action Creators for Panel Log
 */

export var logsRequest = function logsRequest(logType) {
  return {
    type: PANEL_LOG(logType).requestInProgress
  };
};
export var handleResponse = function handleResponse(data, logType) {
  return {
    type: PANEL_LOG(logType).responseReceive,
    data: data
  };
};
export var requestFail = function requestFail(logType) {
  return {
    type: PANEL_LOG(logType).requestFail
  };
};
export function fetchLogs(url, logType) {
  return function (dispatch) {
    dispatch(logsRequest(logType));
    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': window.CSRF
      }
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(handleResponse(json, logType));
    })["catch"](function () {
      return dispatch(requestFail(logType));
    });
  };
}